var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Attachments',{attrs:{"label":_vm.$lang.attachments,"isDisabledAddButton":_vm.isReadonly,"uploaderName":"center_execute_case","resourceName":"person_content","getListMethod":_vm.handleGetAttachments,"createMethod":_vm.handleCreateAttachment,"updateMethod":_vm.handleUpdateAttachment,"deleteMethod":_vm.handleDeleteAttachment}})
}
var staticRenderFns = []

export { render, staticRenderFns }